import React from "react";

/** Whether these results are all of them: the full scan may still be out. */
export const SearchCoverage = ({
  searchingAll,
  partial,
}: {
  searchingAll: boolean;
  partial: boolean;
}) =>
  searchingAll || partial ? (
    <p
      role="status"
      className="px-4 py-3 text-center text-[13px] text-white/55"
    >
      {searchingAll
        ? "Searching all members…"
        : "Some older members and coaches may be missing."}
    </p>
  ) : null;
